module.exports = __webpack_public_path__ + "img/conhome-full-logo.2a210834.svg";